//@flow
import React, { Component } from 'react'
import { FormControl, Select, MenuItem, theme, styled } from '@hiver/hiver-ui-kit';

const MenuItemContent = styled('div')`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-right: 10px;
`

const fontFamily = '"Lato", "Roboto", "Arial", Helvetica, sans-serif';

const HSelect = styled(Select)(() => ({
        height: 41,
        fontFamily,
        "& :before": {
            display: 'none'
        },
        "& :after": {
            display: 'none'
        },
    "& .MuiSelect-select": {
        marginTop: 6,
        '&:focus': {
            background: 'none'
        }
    }
}));

const HFormControl = styled(FormControl)(() => ({
    marginRight: theme.spacing(),
    minWidth: 70,
    fontFamily,
    borderBottom: '1px solid rgba(47, 56, 97, 0.4)',
    '& > div:before': {
        display: 'none',
    },
    '& > div:after': {
        display: 'none',
    }
}));

const HMenuItem = styled(MenuItem)(() => ({
    fontFamily,
}));

class SelectInput extends Component<Props> {
    static defaultProps = {
        data: []
    }
    render(){
        const { data, value } = this.props;
        const menuItems = data.map((d: any) => {
            return <HMenuItem 
                key={d.label} 
                value={d.value}>
                    <MenuItemContent>
                        <div>{d.value}</div>
                        <div>{d.name}</div>
                    </MenuItemContent>
            </HMenuItem>
        });
        return <HFormControl variant="standard">
            <HSelect 
                value={value}
                onChange={this.props.onChange}
                renderValue={value => value}
            >
                { menuItems }
            </HSelect>
        </HFormControl>
        
    }
}

type Props = {
    onChange: Function,
    data: Array<Object>,
    value: any,
}

export default SelectInput;
